import { useAppDispatch, useAppSelector } from 'src/hooks';
import { IDynamicFormValue } from 'src/lib';
import { setLocalFilterValueInSummary } from '../../store/as-is-to-be-slice';

export default function useSummaryGridFilter() {
  const {
    fetchingLocalFiltersData,
    localFilterFormFields,
    localFilterInitialValues
  } = useAppSelector((state) => state.asIsToBeV2);
  const appDispatch = useAppDispatch();

  const onChange = (value: IDynamicFormValue) =>
    appDispatch(setLocalFilterValueInSummary(value));

  return {
    fetchingLocalFiltersData,
    localFilterFormFields,
    localFilterInitialValues,
    onChange
  };
}
